<template>
  <div id="rsp__form-w">
    <div id="rsp__form-c">
      <ValidationMessage v-show="resetState === false">
        Todos os requisitos devem ser cumpridos
      </ValidationMessage>

      <InputText
        :vmodel.sync="password"
        field-label="Nova Senha"
        field-placeholder="Digite aqui sua nova senha"
        field-type="password"
        :state="resetState"
        @change="validatePassword"
      />

      <InputText
        :vmodel.sync="retypePassword"
        field-label="Repita a Nova Senha"
        field-placeholder="Redigite a nova senha"
        field-type="password"
        :state="resetState"
        @change="validatePassword"
      />
    </div>

    <div id="rsp__buttons-c">
      <ButtonFullWidth
        :disabled="disabledButtons"
        @click="resetPassword"
      >
        <div slot="text">Restaurar Senha</div>
      </ButtonFullWidth>

      <ButtonFullWidth
        :disabled="disabledButtons"
        button-color="white"
        @click="redirectToLoginPage"
      >
        <div slot="text">Realizar Login</div>
      </ButtonFullWidth>
    </div>
  </div>
</template>

<script>
  import ValidationMessage from '@/views/authentication/components/card-layout/components/validation-message';
  import InputText from '@/components/input-text';
  import ButtonFullWidth from '@/components/buttons/button-full-width';

  import resetPasswordMixin from '@/mixins/reset-password';

  export default {
    name: 'ResetPasswordCardForm',
    components: {
      InputText,
      ButtonFullWidth,
      ValidationMessage
    },
    mixins: [resetPasswordMixin],
    data: () => ({
      password: '',
      retypePassword: '',
      resetState: null,
      disabledButtons: false
    }),
    mounted() {
      this.setEventListenerKeydown();
    },
    destroyed() {
      this.removeEventListenerKeydown();
    },
    methods: {
      validatePassword() {
        const rule_1 = this.password.length >= 6;
        const rule_2 = this._checkIfHasNumberInString(this.password);
        const rule_3 = this._checkIfHasSpecialCharacterInString(this.password);
        const rule_4 = this.password === this.retypePassword && !!this.password;

        this._updateRuleStatus1(rule_1);
        this._updateRuleStatus2(rule_2);
        this._updateRuleStatus3(rule_3);
        this._updateRuleStatus4(rule_4);

        this.resetState === false && this.validateFields();
      },
      redirectToLoginPage() {
        this.$router.push({ name: 'login' }).catch(() => {});
      },
      redirectToHomePage() {
        this.$router.push({ name: 'home', params: { prefix: this._prefix } }).catch(() => {});
      },
      validateFields() {
        const validation =
          this._ruleStatus1 && this._ruleStatus2 && this._ruleStatus3 && this._ruleStatus4;
        this.resetState = validation ? null : false;

        return validation;
      },
      resetPassword() {
        const validation = this.validateFields();

        if (!validation) return;

        const rawToken = this.$router.currentRoute.params.token ?? '';
        const token = rawToken.replace(/ /g, '+');

        const payload = {
          password: this.password,
          code: token
        };

        this._showLoading();
        this.$http2
          .put('/api/user/update', payload)
          .then(() => {
            this._showRestoredPasswordCard();
          })
          .catch((error) => {
            const email = error.response?.data?.data?.email;
            const status = error.response?.status;

            if (status === 403 && !!email) {
              this._showExpiredLinkResetPasswordCard();
              return;
            }

            if (status === 403 && !email && !localStorage.getItem('userData')) {
              this.redirectToLoginPage();
              return;
            }

            if (status === 403 && !email && localStorage.getItem('userData')) {
              this.redirectToHomePage();
            }
          })
          .finally(() => {
            this._hideLoading();
          });
      },
      setEventListenerKeydown() {
        window.addEventListener('keydown', this.resetPasswordPerKeydown);
      },
      removeEventListenerKeydown() {
        window.removeEventListener('keydown', this.resetPasswordPerKeydown);
      },
      resetPasswordPerKeydown({ key }) {
        key === 'Enter' && this.resetPassword();
      }
    }
  };
</script>

<style lang="scss" scoped>
  #rsp__form-w {
    width: 100%;
    border-top: 1px solid #eeeeee;

    #rsp__form-c {
      gap: 16px;
      margin: 16px 0 32px;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    #rsp__buttons-c {
      gap: 16px 0;

      display: flex;
      flex-direction: column;
    }
  }
</style>
